import { useState } from "react";
import styled from "styled-components";
import UpdatePasswordModal from "../../components/PasswordModal";
import SubTitle from "../../components/SubTitle";

const Container = styled.div`
  width: 100%;
`;

const ButtonContainer = styled.div`
  width: 100%;
`;

const Button = styled.button`
  display: block;
  margin: 0 auto;
  margin-top: 98px;
  width: 100px;
  height: 46px;
  border-radius: 12px;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  background-color: #00a7db;

  &:hover {
    background-color: #0087b3;
  }
`;

export const PasswordSetting = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Container>
      <SubTitle title="비밀번호 변경" />
      <Button onClick={() => setIsOpen(true)}>변경</Button>
      {isOpen && <UpdatePasswordModal onClose={() => setIsOpen(false)} />}
    </Container>
  );
};

